import { render, staticRenderFns } from "./modal-termos.vue?vue&type=template&id=63bc0323&scoped=true"
import script from "./modal-termos.vue?vue&type=script&lang=js"
export * from "./modal-termos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bc0323",
  null
  
)

export default component.exports